import React from 'react';
import clsx from 'clsx';
import { Button, Header } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { toast } from 'react-toastify';
import { hasMinimumLength } from '@/utils/resultsHelper';
import { setCookie } from '@/utils/cookies';
import Selectors from '@/vocabularies/hooks/selectors';
import { trackingCookie } from '../constants';

const AnalyticsConsentToast = () => {
  const { url } = Selectors.useCookiePrivacyLink();
  const applyTrackingSettings = (value) => {
    setCookie(trackingCookie.NAME, value, { expires: 365 });
    toast.dismiss(trackingCookie.toastID);
  };

  return (
    <div className="aridhia-analytics-consent-toast toast-message">
      <Header as="h2" className="f-13 mb-0 bold">
        <FormattedMessage id="toast.analytics.title" />
      </Header>
      <p className="f-12">
        <FormattedMessage id="toast.analytics.cookie.1" />
        {hasMinimumLength(url) && (
          <>
            <FormattedMessage id="toast.analytics.privacy.1" />
            <a href={url} target="_blank" rel="noopener noreferrer" className="underline">
              <FormattedMessage id="toast.analytics.privacy.2" />
            </a>
          </>
        )}
        <FormattedMessage id="toast.analytics.cookie.2" />
      </p>
      <div className={clsx('flex', hasMinimumLength(url) ? 'justify-between' : 'justify-end')}>
        {hasMinimumLength(url) && (
          <Button
            size="mini"
            className="border-a"
            as="a"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            id="cookiePrivacy"
          >
            <FormattedMessage id="toast.analytics.settings" />
          </Button>
        )}
        <span>
          <Button size="mini" className="mr-10" onClick={() => applyTrackingSettings(false)} id="rejectCookie">
            <FormattedMessage id="toast.analytics.reject" />
          </Button>
          <Button size="mini" className="positive" onClick={() => applyTrackingSettings(true)} id="acceptCookie">
            <FormattedMessage id="toast.analytics.accept" />
          </Button>
        </span>
      </div>
    </div>
  );
};

export default AnalyticsConsentToast;
